import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LocationService } from '@services/location.service';
import { firstValueFrom } from 'rxjs';
import { Location } from 'src/app/models/location.model';

export const locationResolver = async (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  locationService: LocationService = inject(LocationService),
  router: Router = inject(Router),
): Promise<Location> => {
  const locationUuid = route.paramMap.get('locationUuid');
  // TODO: guard clause for locationUuid + display error message if not present or invalid

  let location = locationService.getLocation();
  if (location.id) {
    console.log('locationResolverService - return cached location');
    return location;
  } else {
    console.log('locationResolverService - do the http call to fetch location');
    location = await firstValueFrom(locationService.fetchLocation(locationUuid));
    if (!location) {
      router.navigate(['/page-not-found']);
      throw new Error('Location not found');
    }
    return location;
  }
};
